// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rug {
  font-family: Helvetica;
  font-size: 16px;
  color: #3d4852;
}
.rug img {
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
}
.rug .rug-file-input {
  display: none !important;
}
.rug .rug-item {
  justify-content: center;
  -webkit-user-select: none;
          user-select: none;
  cursor: grab;
}
.rug .rug-items.__card {
  display: grid;
  grid-gap: 0;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  margin: 0 -10px;
  min-height: 220px;
}
@media (max-width: 450px) {
  .rug .rug-items.__card {
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  }
}
.rug .rug-items.__card .rug-item {
  display: flex;
  justify-content: center;
  align-items: center;
}
.rug .rug-items.__list {
  padding-top: 30px;
  min-height: 220px;
}
.rug .rug-handle {
  width: 100%;
  height: 290px;
  overflow: hidden;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.rug .rug-handle:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: calc(100% - 8px);
  height: calc(100% - 8px);
  border-radius: 4px;
  border: 4px solid #3d4852;
}
.rug .rug-handle svg.rug-handle-icon {
  width: 70px;
}
.rug .rug-handle svg.rug-handle-icon polyline, .rug .rug-handle svg.rug-handle-icon line {
  fill: none;
  stroke: #3d4852;
  stroke-linejoin: round;
  stroke-width: 2px;
  stroke-linecap: round;
}
.rug .rug-handle.__dragging:before {
  border: 4px dashed #007aff;
  background-color: rgba(0, 122, 255, 0.15);
}
.rug .rug-handle.__dragging svg polyline, .rug .rug-handle.__dragging svg line {
  stroke: #007aff;
}
.rug .rug-handle.__dragging .__arrow {
  animation: 1s up-arrow forwards infinite;
}
.rug .rug-handle .rug-handle-info {
  position: relative;
}
.rug .rug-handle .rug-handle-info .rug-handle-drop-text {
  font-size: 22px;
}
.rug .rug-handle .rug-handle-info .rug-handle-button {
  background-color: #007aff;
  border-radius: 3px;
  padding: 7px 12px;
  font-size: 16px;
  color: #f5f5f5;
  text-align: center;
  cursor: pointer;
  max-width: 250px;
  display: block;
  margin: 0 auto;
}
.rug .rug-handle .rug-handle-info .rug-handle-button:hover {
  background-color: rgba(0, 122, 255, 0.8);
}
.rug .rug-handle .rug-handle-info span {
  text-align: center;
  padding: 10px 0;
  font-size: 17px;
  display: block;
}

@keyframes up-arrow {
  0%, 50% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-5px);
  }
  100% {
    transform: translateY(0px);
  }
}
@media (max-width: 960px) {
  .rug .rug-handle {
    height: 170px;
  }
  .rug .rug-handle svg {
    width: 50px;
  }
  .rug .rug-handle .rug-handle-drop-text, .rug .rug-handle span {
    display: none !important;
  }
}
.rug-card {
  width: 200px;
  height: 200px;
  background-color: #3d4852;
  border-radius: 5px;
  position: relative;
  font-family: Helvetica;
  overflow: hidden;
  cursor: pointer;
  margin: 10px;
}
@media (max-width: 450px) {
  .rug-card {
    width: 160px;
    height: 160px;
  }
}
.rug-card.__error {
  border: 3px solid #ff2d55;
}
.rug-card .rug-card-image {
  width: 100%;
  height: 100%;
  background-position: 50%;
  background-size: contain;
  background-repeat: no-repeat;
}
.rug-card .rug-card-name {
  position: absolute;
  z-index: 15;
  height: 100px;
  width: 100%;
  font-weight: 700;
  font-size: 12px;
  white-space: nowrap;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.8) 0, rgba(0, 0, 0, 0.7) 29%, transparent);
  background-blend-mode: multiply;
  color: #f5f5f5;
}
.rug-card .rug-card-name > div {
  margin: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.rug-card .rug-card-size {
  color: #c3c3c3;
  font-size: 11px;
}
.rug-card .rug-card-progress {
  position: absolute;
  top: calc(50% - 25px);
  left: calc(50% - 25px);
  width: 50px;
  height: 50px;
  display: block;
}
.rug-card .rug-card-progress .__progress-cricle {
  stroke: #007aff;
  fill: none;
  stroke-width: 5;
  stroke-linecap: round;
  transition: stroke-dasharray 200ms ease;
}
.rug-card .rug-card-progress-count {
  position: absolute;
  top: calc(50% - 25px);
  left: calc(50% - 25px);
  width: 50px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  color: rgb(255, 255, 255);
  font-weight: bold;
}
.rug-card .rug-card-refresh {
  position: absolute;
  top: calc(50% - 25px);
  left: calc(50% - 25px);
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 20;
  border: 2px solid transparent;
}
.rug-card .rug-card-refresh:hover {
  background-color: rgba(255, 255, 255, 0.9);
  border: 2px solid #3d4852;
}
.rug-card .rug-card-refresh .__refresh-icon g {
  fill: #3d4852;
}
.rug-card .rug-card-refresh.__spin {
  animation: __spin 1000ms linear infinite;
  border: 2px solid #007aff !important;
}
.rug-card .rug-card-refresh.__spin .__refresh-icon g {
  fill: #007aff;
}
.rug-card .rug-card-upload-button {
  position: absolute;
  top: calc(50% - 25px);
  left: calc(50% - 25px);
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 20;
  text-align: center;
  border: 2px solid transparent;
}
.rug-card .rug-card-upload-button svg {
  width: 25px;
  margin-top: 6px;
}
.rug-card .rug-card-upload-button svg polyline, .rug-card .rug-card-upload-button svg line {
  fill: none;
  stroke: #3d4852;
  stroke-linejoin: round;
  stroke-width: 3px;
  stroke-linecap: round;
}
.rug-card .rug-card-upload-button:hover {
  border: 2px solid #007aff;
  background-color: rgba(255, 255, 255, 0.9);
}
.rug-card .rug-card-upload-button:hover svg polyline, .rug-card .rug-card-upload-button:hover svg line {
  stroke: rgb(0, 122, 255);
}
.rug-card .rug-card-upload-button:hover svg .__arrow {
  animation: 1s up-arrow forwards infinite;
}
.rug-card .rug-card-remove {
  position: absolute;
  bottom: 0;
  right: 0;
  color: white;
  background-color: #3d4852;
  opacity: 0.75;
  border-radius: 9999px;
  margin: 4px;
  padding: 4px;
  width: 22px;
  height: 22px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1.5px solid transparent;
  transition: border 200ms ease;
  cursor: pointer;
}
.rug-card .rug-card-remove:hover {
  border: 1.5px solid #fff;
}
.rug-card .rug-card-remove svg {
  stroke: currentColor;
  height: 18px;
  width: 18px;
}

@keyframes __spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.rug-list {
  width: 100%;
  background-color: #3d4852;
  border-radius: 3px;
  position: relative;
  font-family: Helvetica;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  margin-bottom: 10px;
}
.rug-list.__error {
  border: 3px solid #ff2d55;
}
.rug-list .rug-list-progress {
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 5px;
  background: #007aff;
  border: 3px;
  opacity: 0;
  transition: all 200ms ease;
}
.rug-list .rug-list-progress.__active {
  opacity: 1;
}
.rug-list .rug-list-progress-count {
  position: absolute;
  bottom: 5px;
  right: 5px;
  color: #f5f5f5;
  font-size: 13px;
  opacity: 0;
  transition: all 200ms ease;
}
.rug-list .rug-list-progress-count.__active {
  opacity: 1;
}
.rug-list .rug-list-refresh {
  position: absolute;
  bottom: 5px;
  right: 5px;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 20;
  border: 2px solid transparent;
  cursor: pointer;
}
.rug-list .rug-list-refresh:hover {
  background-color: rgba(255, 255, 255, 0.9);
}
.rug-list .rug-list-refresh .__refresh-icon g {
  fill: #3d4852;
}
.rug-list .rug-list-refresh.__spin {
  animation: __spin 1000ms linear infinite;
}
.rug-list .rug-list-refresh.__spin .__refresh-icon g {
  fill: #007aff;
}
.rug-list .rug-list-upload-button {
  position: absolute;
  bottom: 5px;
  right: 5px;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 20;
  text-align: center;
  border: 2px solid transparent;
  cursor: pointer;
}
.rug-list .rug-list-upload-button svg {
  width: 15px;
  margin-top: 2px;
}
.rug-list .rug-list-upload-button svg polyline, .rug-list .rug-list-upload-button svg line {
  fill: none;
  stroke: #3d4852;
  stroke-linejoin: round;
  stroke-width: 3px;
  stroke-linecap: round;
}
.rug-list .rug-list-upload-button:hover {
  background-color: rgba(255, 255, 255, 0.9);
}
.rug-list .rug-list-upload-button:hover svg polyline, .rug-list .rug-list-upload-button:hover svg line {
  stroke: rgb(0, 122, 255);
}
.rug-list .rug-list-upload-button:hover svg .__arrow {
  animation: 1s up-arrow forwards infinite;
}
.rug-list .rug-list-image {
  width: 100px;
  height: 70px;
  padding: 5px;
}
.rug-list .rug-list-image img {
  width: 100%;
  height: 100%;
}
.rug-list .rug-list-content {
  padding: 5px;
  width: calc(100% - 120px);
}
.rug-list .rug-list-content .rug-list-name {
  color: #f5f5f5;
  white-space: nowrap;
  font-size: 14px;
  text-overflow: ellipsis;
  position: relative;
  overflow: hidden;
  width: calc(100% - 40px);
}
.rug-list .rug-list-content .rug-list-size {
  color: #ddd;
  font-size: 12px;
  margin-top: 3px;
}
.rug-list .rug-list-remove {
  position: absolute;
  z-index: 40;
  top: 0;
  right: 0;
  color: #ccc;
  opacity: 0.75;
  border-radius: 9999px;
  padding: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.rug-list .rug-list-remove svg {
  stroke: currentColor;
  height: 22px;
  width: 22px;
}
.rug-list .rug-list-remove:hover {
  color: #fff;
}

@keyframes __spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.__sorting .rug-list, .__sorting .rug-card {
  cursor: grab;
}

.rug-dragging-item {
  cursor: grabbing;
}
.rug-dragging-item > div:not(.rug-list) {
  transform: scale(1.1);
}`, "",{"version":3,"sources":["webpack://./packages/react-upload-gallery/dist/style.scss"],"names":[],"mappings":"AAAA;EACC,sBAAA;EACA,eAAA;EACA,cAAA;AACD;AACC;EACC,oBAAA;EACA,yBAAA;UAAA,iBAAA;AACF;AAEC;EACC,wBAAA;AAAF;AAGC;EACC,uBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,YAAA;AADF;AAIC;EAEC,aAAA;EACA,WAAA;EACA,4DAAA;EACA,eAAA;EACA,iBAAA;AAFF;AAIE;EARD;IASE,4DAAA;EADD;AACF;AAGE;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;AADH;AAKC;EACC,iBAAA;EACA,iBAAA;AAHF;AAMC;EACC,WAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AAJF;AAME;EACC,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,uBAAA;EACA,wBAAA;EACA,kBAAA;EACA,yBAAA;AAJH;AAOE;EACC,WAAA;AALH;AAOG;EACC,UAAA;EACA,eAAA;EACA,sBAAA;EACA,iBAAA;EACA,qBAAA;AALJ;AAYG;EACC,0BAAA;EACA,yCAAA;AAVJ;AAeI;EACC,eAAA;AAbL;AAiBG;EACC,wCAAA;AAfJ;AAmBE;EACC,kBAAA;AAjBH;AAmBG;EACC,eAAA;AAjBJ;AAoBG;EACC,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;AAlBJ;AAoBI;EACC,wCAAA;AAlBL;AAsBG;EACC,kBAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;AApBJ;;AA0BA;EACC;IACC,0BAAA;EAvBA;EA0BD;IACC,2BAAA;EAxBA;EA2BD;IACC,0BAAA;EAzBA;AACF;AA6BA;EACC;IACC,aAAA;EA3BA;EA4BA;IACC,WAAA;EA1BD;EA4BA;IACC,wBAAA;EA1BD;AACF;AA8BA;EACC,YAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;AA5BD;AA8BC;EAXD;IAYE,YAAA;IACA,aAAA;EA3BA;AACF;AA6BC;EACC,yBAAA;AA3BF;AA8BC;EACC,WAAA;EACA,YAAA;EACA,wBAAA;EACA,wBAAA;EACA,4BAAA;AA5BF;AA+BC;EACC,kBAAA;EACA,WAAA;EACA,aAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,8FAAA;EACA,+BAAA;EACA,cAAA;AA7BF;AA+BE;EACC,YAAA;EAEA,gBAAA;EACA,uBAAA;AA7BH;AAiCC;EACC,cAAA;EACA,eAAA;AA/BF;AAkCC;EACC,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAhCF;AAkCE;EACC,eAAA;EACA,UAAA;EACA,eAAA;EACA,qBAAA;EACA,uCAAA;AAhCH;AAoCC;EACC,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,yBAAA;EACA,iBAAA;AAlCF;AAqCC;EACC,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,0CAAA;EACA,WAAA;EACA,6BAAA;AAnCF;AAqCE;EACC,0CAAA;EACA,yBAAA;AAnCH;AAsCE;EACC,aAAA;AApCH;AAuCE;EACC,wCAAA;EACA,oCAAA;AArCH;AAuCG;EACC,aAAA;AArCJ;AA2CC;EACC,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,0CAAA;EACA,WAAA;EACA,kBAAA;EACA,6BAAA;AAzCF;AA4CE;EACC,WAAA;EACA,eAAA;AA1CH;AA4CG;EACC,UAAA;EACA,eAAA;EACA,sBAAA;EACA,iBAAA;EACA,qBAAA;AA1CJ;AA8CE;EACC,yBAAA;EACA,0CAAA;AA5CH;AA+CI;EACC,wBAAA;AA7CL;AAgDI;EACC,wCAAA;AA9CL;AAqDC;EACC,kBAAA;EACA,SAAA;EACA,QAAA;EACA,YAAA;EACA,yBAAA;EACA,aAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,+BAAA;EACA,6BAAA;EACA,eAAA;AAnDF;AAqDE;EACC,wBAAA;AAnDH;AAsDE;EACC,oBAAA;EACA,YAAA;EACA,WAAA;AApDH;;AAyDA;EACC;IACC,uBAAA;EAtDA;EAyDD;IACC,yBAAA;EAvDA;AACF;AA2DA;EACC,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AAzDD;AA2DC;EACC,yBAAA;AAzDF;AA4DC;EACC,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EACA,UAAA;EACA,0BAAA;AA1DF;AA4DE;EACC,UAAA;AA1DH;AA6DC;EACC,kBAAA;EACA,WAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;EACA,UAAA;EACA,0BAAA;AA3DF;AA6DE;EACC,UAAA;AA3DH;AA+DC;EACC,kBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,0CAAA;EACA,WAAA;EACA,6BAAA;EACA,eAAA;AA7DF;AA+DE;EACC,0CAAA;AA7DH;AAgEE;EACC,aAAA;AA9DH;AAiEE;EACC,wCAAA;AA/DH;AAiEG;EACC,aAAA;AA/DJ;AAoEC;EACC,kBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,0CAAA;EACA,WAAA;EACA,kBAAA;EACA,6BAAA;EACA,eAAA;AAlEF;AAqEE;EACC,WAAA;EACA,eAAA;AAnEH;AAqEG;EACC,UAAA;EACA,eAAA;EACA,sBAAA;EACA,iBAAA;EACA,qBAAA;AAnEJ;AAuEE;EACC,0CAAA;AArEH;AAwEI;EACC,wBAAA;AAtEL;AAyEI;EACC,wCAAA;AAvEL;AA6EC;EACC,YAAA;EACA,YAAA;EACA,YAAA;AA3EF;AA6EE;EACC,WAAA;EACA,YAAA;AA3EH;AA+EC;EACC,YAAA;EACA,yBAAA;AA7EF;AA+EE;EACC,cAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wBAAA;AA7EH;AAgFE;EACC,WAAA;EACA,eAAA;EACA,eAAA;AA9EH;AAiFC;EACC,kBAAA;EACA,WAAA;EACA,MAAA;EACA,QAAA;EACA,WAAA;EACA,aAAA;EACA,qBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AA/EF;AAiFE;EACC,oBAAA;EACA,YAAA;EACA,WAAA;AA/EH;AAkFE;EACC,WAAA;AAhFH;;AAqFA;EACC;IACA,uBAAA;EAlFC;EAqFD;IACA,yBAAA;EAnFC;AACF;AAwFC;EACC,YAAA;AAtFF;;AA0FA;EACC,gBAAA;AAvFD;AAwFC;EACC,qBAAA;AAtFF","sourcesContent":[".rug {\n\tfont-family: Helvetica;\n\tfont-size: 16px;\n\tcolor: #3d4852;\n\n\timg {\n\t\tpointer-events: none;\n\t\tuser-select: none;\n\t}\n\n\t.rug-file-input {\n\t\tdisplay: none !important;\n\t}\n\n\t.rug-item {\n\t\tjustify-content: center;\n\t\tuser-select: none;\n\t\tcursor: grab;\n\t}\n\t\n\t.rug-items.__card {\n\t\tdisplay: -ms-grid;\n\t\tdisplay: grid;\n\t\tgrid-gap: 0;\n\t\tgrid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n\t\tmargin: 0 -10px;\n\t\tmin-height: 220px;\n\n\t\t@media(max-width: 450px) {\n\t\t\tgrid-template-columns: repeat(auto-fill, minmax(180px, 1fr));\n\t\t}\n\n\t\t.rug-item {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\t\t}\n\t}\n\n\t.rug-items.__list {\n\t\tpadding-top: 30px;\n\t\tmin-height: 220px;\n\t}\n\n\t.rug-handle {\n\t\twidth: 100%;\n\t\theight: 290px;\n\t\toverflow: hidden;\n\t\tposition: relative;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tflex-direction: column;\n\n\t\t&:before {\n\t\t\tcontent: '';\n\t\t\tposition: absolute;\n\t\t\ttop: 0;\n\t\t\tleft: 0;\n\t\t\twidth: calc(100% - 8px);\n\t\t\theight: calc(100% - 8px);\n\t\t\tborder-radius: 4px;\n\t\t\tborder: 4px solid #3d4852;\n\t\t}\n\n\t\tsvg.rug-handle-icon {\n\t\t\twidth: 70px;\n\n\t\t\tpolyline, line {\n\t\t\t\tfill: none;\n\t\t\t\tstroke: #3d4852;\n\t\t\t\tstroke-linejoin: round;\n\t\t\t\tstroke-width: 2px;\n\t\t\t\tstroke-linecap: round;\n\t\t\t}\n\t\t}\n\n\t\t&.__dragging {\n\t\t\t\n\n\t\t\t&:before {\n\t\t\t\tborder: 4px dashed #007aff;\n\t\t\t\tbackground-color: rgba(0, 122, 255, 0.15);\n\t\t\t}\n\n\t\t\tsvg {\n\n\t\t\t\tpolyline, line {\n\t\t\t\t\tstroke: #007aff;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.__arrow {\n\t\t\t\tanimation: 1s up-arrow forwards infinite;\n\t\t\t}\n\t\t}\n\n\t\t.rug-handle-info {\n\t\t\tposition: relative;\n\n\t\t\t.rug-handle-drop-text {\n\t\t\t\tfont-size: 22px;\n\t\t\t}\n\n\t\t\t.rug-handle-button {\n\t\t\t\tbackground-color: #007aff;\n\t\t\t\tborder-radius: 3px;\n\t\t\t\tpadding: 7px 12px;\n\t\t\t\tfont-size: 16px;\n\t\t\t\tcolor: #f5f5f5;\n\t\t\t\ttext-align: center;\n\t\t\t\tcursor: pointer;\n\t\t\t\tmax-width: 250px;\n\t\t\t\tdisplay: block;\n\t\t\t\tmargin: 0 auto;\n\n\t\t\t\t&:hover {\n\t\t\t\t\tbackground-color: rgba(0, 122, 255, 0.8);\n\t\t\t\t}\n\t\t\t}\n\n\t\t\tspan {\n\t\t\t\ttext-align: center;\n\t\t\t\tpadding: 10px 0;\n\t\t\t\tfont-size: 17px;\n\t\t\t\tdisplay: block;\n\t\t\t}\n\t\t}\n\t}\n}\n\n@keyframes up-arrow {\n\t0%, 50% {\n\t\ttransform: translateY(0px);\n\t}\n\n\t50% {\n\t\ttransform: translateY(-5px);\n\t}\n\n\t100% {\n\t\ttransform: translateY(0px);\n\t}\n}\n\n\n@media (max-width: 960px) {\n\t.rug .rug-handle {\n\t\theight: 170px;\n\t\tsvg {\n\t\t\twidth: 50px;\n\t\t}\n\t\t.rug-handle-drop-text, span {\n\t\t\tdisplay: none !important;\n\t\t}\n\t}\n}\n\n.rug-card {\n\twidth: 200px;\n\theight: 200px;\n\tbackground-color: #3d4852;\n\tborder-radius: 5px;\n\tposition: relative;\n\tfont-family: Helvetica;\n\toverflow: hidden;\n\tcursor: pointer;\n\tmargin: 10px;\n\n\t@media(max-width: 450px) {\n\t\twidth: 160px;\n\t\theight: 160px;\n\t}\n\n\t&.__error {\n\t\tborder: 3px solid #ff2d55;\n\t}\n\n\t.rug-card-image {\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tbackground-position: 50%;\n\t\tbackground-size: contain;\n\t\tbackground-repeat: no-repeat;\n\t}\n\n\t.rug-card-name {\n\t\tposition: absolute;\n\t\tz-index: 15;\n\t\theight: 100px;\n\t\twidth: 100%;\n\t\tfont-weight: 700;\n\t\tfont-size: 12px;\n\t\twhite-space: nowrap;\n\t\tbackground: linear-gradient(180deg, rgba(0, 0, 0, 0.8) 0, rgba(0, 0, 0, 0.7) 29%, transparent);\n\t\tbackground-blend-mode: multiply;\n\t\tcolor: #f5f5f5;\n\n\t\t> div {\n\t\t\tmargin: 10px;\n\t\t\toverflow: hidden;\n\t\t\toverflow: hidden;\n\t\t\ttext-overflow: ellipsis;\n\t\t}\n\t}\n\n\t.rug-card-size {\n\t\tcolor: #c3c3c3;\n\t\tfont-size: 11px\n\t}\n\n\t.rug-card-progress {\n\t\tposition: absolute;\n\t\ttop: calc(50% - 25px);\n\t\tleft: calc(50% - 25px);\n\t\twidth: 50px;\n\t\theight: 50px;\n\t\tdisplay: block;\n\n\t\t.__progress-cricle {\n\t\t\tstroke: #007aff;\n\t\t\tfill: none;\n\t\t\tstroke-width: 5;\n\t\t\tstroke-linecap: round;\n\t\t\ttransition: stroke-dasharray 200ms ease;\n\t\t}\n\t}\n\n\t.rug-card-progress-count {\n\t\tposition: absolute;\n\t\ttop: calc(50% - 25px);\n\t\tleft: calc(50% - 25px);\n\t\twidth: 50px;\n\t\theight: 50px;\n\t\ttext-align: center;\n\t\tline-height: 50px;\n\t\tcolor: rgb(255, 255, 255);\n\t\tfont-weight: bold;\n\t}\n\n\t.rug-card-refresh {\n\t\tposition: absolute;\n\t\ttop: calc(50% - 25px);\n\t\tleft: calc(50% - 25px);\n\t\twidth: 50px;\n\t\theight: 50px;\n\t\tborder-radius: 50%;\n\t\tbackground-color: rgba(255, 255, 255, 0.7);\n\t\tz-index: 20;\n\t\tborder: 2px solid transparent;\n\n\t\t&:hover {\n\t\t\tbackground-color: rgba(255, 255, 255, 0.9);\n\t\t\tborder: 2px solid #3d4852;\n\t\t}\n\n\t\t.__refresh-icon g {\n\t\t\tfill: #3d4852;\n\t\t}\n\n\t\t&.__spin {\n\t\t\tanimation: __spin 1000ms linear infinite;\n\t\t\tborder: 2px solid #007aff !important;\n\n\t\t\t.__refresh-icon g {\n\t\t\t\tfill: #007aff;\n\t\t\t}\n\t\t}\n\t}\n\n\n\t.rug-card-upload-button {\n\t\tposition: absolute;\n\t\ttop: calc(50% - 25px);\n\t\tleft: calc(50% - 25px);\n\t\twidth: 50px;\n\t\theight: 50px;\n\t\tborder-radius: 50%;\n\t\tbackground-color: rgba(255, 255, 255, 0.7);\n\t\tz-index: 20;\n\t\ttext-align: center;\n\t\tborder: 2px solid transparent;\n\n\t\t\n\t\tsvg {\n\t\t\twidth: 25px;\n\t\t\tmargin-top: 6px;\n\n\t\t\tpolyline, line {\n\t\t\t\tfill: none;\n\t\t\t\tstroke: #3d4852;\n\t\t\t\tstroke-linejoin: round;\n\t\t\t\tstroke-width: 3px;\n\t\t\t\tstroke-linecap: round;\n\t\t\t}\n\t\t}\n\n\t\t&:hover {\n\t\t\tborder: 2px solid #007aff;\n\t\t\tbackground-color: rgba(255, 255, 255, 0.9);\n\n\t\t\tsvg {\n\t\t\t\tpolyline, line {\n\t\t\t\t\tstroke: rgb(0, 122, 255)\n\t\t\t\t}\n\n\t\t\t\t.__arrow {\n\t\t\t\t\tanimation: 1s up-arrow forwards infinite;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t\n\n\t.rug-card-remove {\n\t\tposition: absolute;\n\t\tbottom: 0;\n\t\tright: 0;\n\t\tcolor: white;\n\t\tbackground-color: #3d4852;\n\t\topacity: .75;\n\t\tborder-radius: 9999px;\n\t\tmargin: 4px;\n\t\tpadding: 4px;\n\t\twidth: 22px;\n\t\theight: 22px;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tborder: 1.5px solid transparent;\n\t\ttransition: border 200ms ease;\n\t\tcursor: pointer;\n\n\t\t&:hover {\n\t\t\tborder: 1.5px solid #fff;\n\t\t}\n\n\t\tsvg {\n\t\t\tstroke: currentColor;\n\t\t\theight: 18px;\n\t\t\twidth: 18px;\n\t\t}\n\t}\n}\n\n@keyframes __spin {\n\tfrom {\n\t\ttransform: rotate(0deg);\n\t}\n\n\tto {\n\t\ttransform: rotate(360deg);\n\t}\n}\n\n\n.rug-list {\n\twidth: 100%;\n\tbackground-color: #3d4852;\n\tborder-radius: 3px;\n\tposition: relative;\n\tfont-family: Helvetica;\n\toverflow: hidden;\n\tdisplay: flex;\n\tflex-direction: row;\n\tmargin-bottom: 10px;\n\n\t&.__error {\n\t\tborder: 3px solid #ff2d55;\n\t}\n\n\t.rug-list-progress {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\twidth: 0;\n\t\theight: 5px;\n\t\tbackground: #007aff;\n\t\tborder: 3px;\n\t\topacity: 0;\n\t\ttransition: all 200ms ease;\n\n\t\t&.__active {\n\t\t\topacity: 1;\n\t\t}\n\t}\n\t.rug-list-progress-count {\n\t\tposition: absolute;\n\t\tbottom: 5px;\n\t\tright: 5px;\n\t\tcolor: #f5f5f5;\n\t\tfont-size: 13px;\n\t\topacity: 0;\n\t\ttransition: all 200ms ease;\n\n\t\t&.__active {\n\t\t\topacity: 1;\n\t\t}\n\t}\n\n\t.rug-list-refresh {\n\t\tposition: absolute;\n\t\tbottom: 5px;\n\t\tright: 5px;\n\t\twidth: 25px;\n\t\theight: 25px;\n\t\tborder-radius: 50%;\n\t\tbackground-color: rgba(255, 255, 255, 0.7);\n\t\tz-index: 20;\n\t\tborder: 2px solid transparent;\n\t\tcursor: pointer;\n\n\t\t&:hover {\n\t\t\tbackground-color: rgba(255, 255, 255, 0.9);\n\t\t}\n\n\t\t.__refresh-icon g {\n\t\t\tfill: #3d4852;\n\t\t}\n\n\t\t&.__spin {\n\t\t\tanimation: __spin 1000ms linear infinite;\n\n\t\t\t.__refresh-icon g {\n\t\t\t\tfill: #007aff;\n\t\t\t}\n\t\t}\n\t}\n\n\t.rug-list-upload-button {\n\t\tposition: absolute;\n\t\tbottom: 5px;\n\t\tright: 5px;\n\t\twidth: 25px;\n\t\theight: 25px;\n\t\tborder-radius: 50%;\n\t\tbackground-color: rgba(255, 255, 255, 0.7);\n\t\tz-index: 20;\n\t\ttext-align: center;\n\t\tborder: 2px solid transparent;\n\t\tcursor: pointer;\n\n\n\t\tsvg {\n\t\t\twidth: 15px;\n\t\t\tmargin-top: 2px;\n\n\t\t\tpolyline, line {\n\t\t\t\tfill: none;\n\t\t\t\tstroke: #3d4852;\n\t\t\t\tstroke-linejoin: round;\n\t\t\t\tstroke-width: 3px;\n\t\t\t\tstroke-linecap: round;\n\t\t\t}\n\t\t}\n\n\t\t&:hover {\n\t\t\tbackground-color: rgba(255, 255, 255, 0.9);\n\n\t\t\tsvg {\n\t\t\t\tpolyline, line {\n\t\t\t\t\tstroke: rgb(0, 122, 255)\n\t\t\t\t}\n\n\t\t\t\t.__arrow {\n\t\t\t\t\tanimation: 1s up-arrow forwards infinite;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.rug-list-image {\n\t\twidth: 100px;\n\t\theight: 70px;\n\t\tpadding: 5px;\n\n\t\timg {\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t}\n\t}\n\n\t.rug-list-content {\n\t\tpadding: 5px;\n\t\twidth: calc(100% - 120px);\n\n\t\t.rug-list-name {\n\t\t\tcolor: #f5f5f5;\n\t\t\twhite-space: nowrap;\n\t\t\tfont-size: 14px;\n\t\t\ttext-overflow: ellipsis;\n\t\t\tposition: relative;\n\t\t\toverflow: hidden;\n\t\t\twidth: calc(100% - 40px);\n\t\t}\n\n\t\t.rug-list-size {\n\t\t\tcolor: #ddd;\n\t\t\tfont-size: 12px;\n\t\t\tmargin-top: 3px;\n\t\t}\n\t}\n\t.rug-list-remove {\n\t\tposition: absolute;\n\t\tz-index: 40;\n\t\ttop: 0;\n\t\tright: 0;\n\t\tcolor: #ccc;\n\t\topacity: .75;\n\t\tborder-radius: 9999px;\n\t\tpadding: 5px;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\n\t\tsvg {\n\t\t\tstroke: currentColor;\n\t\t\theight: 22px;\n\t\t\twidth: 22px;\n\t\t}\n\n\t\t&:hover {\n\t\t\tcolor: #fff;\n\t\t}\n\t}\n}\n\n@keyframes __spin {\n\tfrom {\n\ttransform: rotate(0deg);\n\t}\n\n\tto {\n\ttransform: rotate(360deg);\n\t}\n}\n\n\n.__sorting {\n\t.rug-list, .rug-card {\n\t\tcursor: grab;\n\t}\n}\n\n.rug-dragging-item {\n\tcursor: grabbing;\n\t& > div:not(.rug-list){\n\t\ttransform: scale(1.1);\t\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
